import { render, staticRenderFns } from "./block-header.vue?vue&type=template&id=d44efea4&scoped=true&"
import script from "./block-header.vue?vue&type=script&lang=js&"
export * from "./block-header.vue?vue&type=script&lang=js&"
import style0 from "./block-header.vue?vue&type=style&index=0&id=d44efea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44efea4",
  null
  
)

export default component.exports